'use strict';

function MortgageEmployment() {
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MortgageController];
  this._pageSections = null;
  this._pageSectionActions = null;
  this._callbacks = {};

  this._keepOnStatusChange = '[data-bind$=employment_status],[data-bind$=rental_income_amount]';
  this._keepOnIncomeChange = this._keepOnStatusChange + ',[data-bind$=name],[data-bind$=income_type]';

  // list of elements to clear the error state
  this._elementsToClearError = [];

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    var _this = this;

    if (this.checkMortgageApplicationEligibility()) {
      this.$node = $(this.node);
      this.$done = this.$node.find('.Application__done').on('click', this._onDone.bind(this));

      this._pageSections = {
        applicant: this.$node.find('#subsection__applicant'),
        coapplicant: this.$node.find('#subsection__coapplicant')
      };

      this._pageSectionActions = {
        applicant: 'mortgage_applicant_employment.update_mortgage_employment',
        coapplicant: 'mortgage_coparticipant_employment.update_mortgage_employment'
      };

      this.$formApplicant = this._pageSections.applicant.find('form'); // Get the form element

      // Setup the form element
      this._setupForm(this.$formApplicant, 'mortgage_applicant', 'mortgage_applicant_employment', this._onCreateApplicant.bind(this), this._onEditApplicant.bind(this), this._cancelApplicantClick.bind(this), 0);

      if (this._hasCoApplicant()) {
        this.$formCoApplicant = this._pageSections.coapplicant.find('form'); // Get the form element

        // Setup the from element
        this._setupForm(this.$formCoApplicant, 'mortgage_coparticipant', 'mortgage_coparticipant_employment', this._onCreateCoParticipant.bind(this), this._onEditCoParticipant.bind(this), this._cancelCoApplicantClick.bind(this), 1);
      }

      this.$formSteps = this.$node.find('.form-steps');
      this.$formSteps.mogo().create('FormSteps', {
        steps: [{
          isVisible: true,
          isComplete: this.presenter.hasAction('mortgage_applicant_employment.update_mortgage_employment'),
          isEditable: this.presenter.hasAction('mortgage_applicant_employment.update_mortgage_employment'),
          isActive: !this.presenter.hasAction('mortgage_applicant_employment.update_mortgage_employment'),
          isEnabled: true
        }, {
          isVisible: this._hasCoApplicant(),
          isEnabled: this.presenter.hasAction('mortgage_applicant_employment.update_mortgage_employment'),
          isActive: this.presenter.hasAction('mortgage_applicant_employment.update_mortgage_employment') && !this.presenter.hasAction('mortgage_coparticipant_employment.update_mortgage_employment'),
          isEditable: this.presenter.hasAction('mortgage_coparticipant_employment.update_mortgage_employment'),
          isComplete: this.presenter.hasAction('mortgage_coparticipant_employment.update_mortgage_employment')
        }]
      });

      // Add computed varibales to support showing and hiding the done button and disabling the button
      this.presenter.addComputedVariable('is_persisted', null, function () {
        return _this.presenter.models.mortgage_applicant_employment.isPersistent() && (!_this._hasCoApplicant() || _this.presenter.models.mortgage_coparticipant_employment.isPersistent());
      });

      this.presenter.addComputedVariable('can_continue', ['mortgage_coparticipant.id'], function () {
        return (!_this._hasCoApplicant() || _this.presenter.hasAction('mortgage_coparticipant_employment.update_mortgage_employment')) && _this.presenter.hasAction('mortgage_applicant_employment.update_mortgage_employment');
      });

      this._extendPresenter();
      this.presenter.scanDOM();

      this.analytics.pushEvent('virtual-page-view');
      this.pushAnalyticsMortgageChoices();
    }
  };

  // Helper Method to setup the form
  this._setupForm = function ($form, pModelName, modelName, onCreate, onEdit, onCancel, index) {
    this._addFormAction($form, pModelName + '.create_mortgage_employment', onCreate, modelName + '.update_mortgage_employment', onEdit);
    $form.find("select[name='employment_status']").on('change.clear_all_fields', this._clearAllFields.bind(this, $form, this._keepOnStatusChange));
    $form.find('[name=income_type] input').on('change.clear_income_fields', this._clearAllFields.bind(this, $form, this._keepOnIncomeChange));
    $form.find('button.secondary.hollow').on('click.cancel', onCancel);
    $form.find("button[type='submit']").on('click.save_check', this._checkSubmit.bind(this, modelName, index));
    // $section.find("a.icon--edit").on("click.edit_section", this._editSection.bind(this, $section));
  };

  // Helper Method to clear the
  this._clearAllFields = function ($form, exceptions) {
    var _this2 = this;

    // update income_type
    var status = $form.find('select[name=employment_status]').val();
    var shouldUpdateIncomeType = status === 'pension' || status === 'disability';

    $form.find('[data-bind]').not(exceptions).each(function (i, element) {
      var $element = $(element);
      var field = $element.attr('data-bind');
      var fieldSplit = field.split('.');
      var modelName = fieldSplit[0];
      var fieldName = fieldSplit[1];

      if (shouldUpdateIncomeType && fieldName === 'income_type') {
        // Special case to set the income_type to salary when employment_status is pension or disability
        _this2.presenter.models[modelName].setModelProperty(fieldName, 'salary');
      } else {
        // clearing the field
        _this2.presenter.models[modelName].removeModelProperty(fieldName);
        if (fieldName === 'income_frequency') $form.find('[data-bind*=income_frequency]').mogo().setSelectedIndex(0);
      }

      _this2._elementsToClearError.push($element);
    });
  };

  this._checkSubmit = function (modelName, index) {
    if (this.presenter.hasAction(modelName + '.update_mortgage_employment')) {
      if (this.presenter.models[modelName].isPersistent()) {
        this.$formSteps.mogo().setStepActive(index, false);

        if (index === 0 && !this.presenter.hasAction(this._pageSectionActions.coapplicant)) {
          this._editSection(1);
        }

        return false;
      }
    }
  };

  this._editSection = function (index) {
    this.$formSteps.mogo().setStepEnabled(index, true);
    this.$formSteps.mogo().setStepActive(index, true);
    this.presenter.updateDOM();

    var isCoApplicant = index == 1;
    // only push the page view if the it's the applicant or it's co-applicant and the co-applicant is visible
    if (!isCoApplicant || this._hasCoApplicant()) {
      this.analytics.pushEvent('virtual-page-view', {
        Page: [window.location.href + (isCoApplicant ? '-coapplicant' : '-applicant')]
      });
    }
  };

  this._cancelApplicantClick = function () {
    this.$formSteps.mogo().setStepActive(0, false);

    this.presenter.resetModels('mortgage_applicant_employment');
    this.presenter.scanDOM();

    if (!this.presenter.hasAction('mortgage_coparticipant_employment.update_mortgage_employment')) {
      this._editSection(1);
    }
  };

  this._cancelCoApplicantClick = function () {
    this.$formSteps.mogo().setStepActive(1, false);
    this.presenter.resetModels('mortgage_coparticipant_employment');
    this.presenter.scanDOM();
  };

  this._posthook = function () {
    for (var i = 0; i < this._elementsToClearError.length; i++) {
      this._elementsToClearError[i].mogo().hideError();
    }

    this._elementsToClearError = [];
  };

  this._prehook = function ($form) {
    var path = null;
    var additionalPath = null;
    $form.mogo().removeAllValidationPaths();

    switch ($form.find('[name=employment_status]').mogo().val()) {
      case 'employed':
      case 'maternity_leave':
        var status = $form.find('[name=income_type]').mogo().val();
        if (status) status = status[0];
        switch (status) {
          case 'hourly':
            path = '#/oneOf/0/oneOf/0';
            additionalPath = '#/oneOf/0/required';
            break;
          case 'salary':
            path = '#/oneOf/0/oneOf/1';
            additionalPath = '#/oneOf/0/required';
            break;
          case 'salary_commission':
            path = '#/oneOf/0/oneOf/2';
            additionalPath = '#/oneOf/0/required';
            break;
          case 'commission':
            path = '#/oneOf/0/oneOf/3';
            additionalPath = '#/oneOf/0/required';
            break;
          default:
            path = '#/oneOf/0';
            break;
        }
        break;
      case 'pension':
      case 'disability':
        path = '#/oneOf/1';
        break;
      case 'unemployed':
      case 'homemaker':
        path = '#/oneOf/2';
        break;
      case 'self_employed':
        path = '#/oneOf/3';
        break;
    }
    if (path) $form.mogo().addValidationIncludePath(path);
    if (additionalPath) $form.mogo().addValidationIncludePath(additionalPath);
  };

  this._extendPresenter = function () {
    this.presenter.extendCustomValidations('mortgage_applicant.create_mortgage_employment', {
      _hooks: {
        prehook: this._prehook.bind(this, this.$formApplicant),
        posthook: this._posthook.bind(this)
      }
    });

    this.presenter.extendCustomValidations('mortgage_applicant_employment.update_mortgage_employment', {
      _hooks: {
        prehook: this._prehook.bind(this, this.$formApplicant),
        posthook: this._posthook.bind(this)
      }
    });

    if (this._hasCoApplicant()) {
      this.presenter.extendCustomValidations('mortgage_coparticipant.create_mortgage_employment', {
        _hooks: {
          prehook: this._prehook.bind(this, this.$formCoApplicant),
          posthook: this._posthook.bind(this)
        }
      });

      this.presenter.extendCustomValidations('mortgage_coparticipant_employment.update_mortgage_employment', {
        _hooks: {
          prehook: this._prehook.bind(this, this.$formCoApplicant),
          posthook: this._posthook.bind(this)
        }
      });
    }
  };

  this.destroy = function () {
    var _this3 = this;

    this._super();
    this.presenter.resetModels('mortgage_applicant_employment');
    if (this.presenter.models.mortgage_coparticipant_employment) this.presenter.resetModels('mortgage_coparticipant_employment');

    // remove all callbacks added
    $.each(this._callbacks, function (key, callback) {
      _this3.presenter.removeCallbackFromAction(key, callback);
    });
    this.presenter.removeComputedVariable('can_continue');
    this.presenter.removeComputedVariable('is_persisted');
  };

  this._addFormAction = function ($form, createActionName, createAction, editActionName, editAction) {
    this.presenter.removeActionFromNode($form[0]);
    delete window.mogo.registry.mogoUI.repo[$form.attr('id')];
    var canEdit = this.presenter.hasAction(editActionName);

    if (!canEdit) {
      this.presenter.addActionToNode($form[0], createActionName);
      this._callbacks[createActionName] = this.presenter.addCallbackToAction(createActionName, createAction);
    } else {
      this.presenter.addActionToNode($form[0], editActionName);
      this._callbacks[editActionName] = this.presenter.addCallbackToAction(editActionName, editAction);
    }
  };

  this._hasCoApplicant = function () {
    return this.presenter.models.mortgage.has_supporter == 1;
  };

  this._onCreateApplicant = function (data, response) {
    if (response == 200) {
      // analytics
      var formAnalyticsID = $('#applicant-form').data('analytics-id');
      this.analytics.pushEvent('form-submit', { FormID: [formAnalyticsID] });

      // update model
      this.presenter.updateModel('mortgage_applicant_employment', data);

      // switch form states
      this.$formSteps.mogo().setStepEditable(0, true);
      this.$formSteps.mogo().setStepComplete(0);
      this.$formSteps.mogo().setStepActive(0, false);
      this._editSection(1);

      // update the form
      this._addFormAction(this.$formApplicant, 'mortgage_applicant.create_mortgage_employment', this._onCreateApplicant.bind(this), 'mortgage_applicant_employment.update_mortgage_employment', this._onEditApplicant.bind(this));
    } else {
      // if (data.errors) this.$formApplicant.mogo().parseErrorObject(data.errors); //TODO add this back when kisnon adds it back
      $('#Notification').mogo().get();
    }
  };

  this._onEditApplicant = function (data, response) {
    if (response == 200) {
      // analytics
      var formAnalyticsID = $('#applicant-form').data('analytics-id');
      this.analytics.pushEvent('form-submit', { FormID: [formAnalyticsID] });

      // update model
      this.presenter.updateModel('mortgage_applicant_employment', data);

      // switch form states
      if (!this.presenter.hasAction('mortgage_coparticipant_employment.update_mortgage_employment')) {
        this._editSection(1);
      } else {
        this.$formSteps.mogo().setStepActive(0, false);
        this.presenter.scanDOM();
      }
    } else {
      // if (data.errors) this.$formApplicant.mogo().parseErrorObject(data.errors) //TODO add this back when kisnon adds it back
      $('#Notification').mogo().get();
    }
  };

  this._onCreateCoParticipant = function (data, response) {
    if (response == 200) {
      // update model
      this.presenter.updateModel('mortgage_coparticipant_employment', data);

      // switch form states
      this.$formSteps.mogo().setStepComplete(1);
      this.$formSteps.mogo().setStepEditable(1, true);
      this.$formSteps.mogo().setStepActive(1, false);

      // analytics
      var formAnalyticsID = $('#coapplicant-form').data('analytics-id');
      this.analytics.pushEvent('form-submit', { FormID: [formAnalyticsID] });

      // update the form
      this._addFormAction(this.$formCoApplicant, 'mortgage_coparticipant.create_mortgage_employment', this._onCreateCoParticipant.bind(this), 'mortgage_coparticipant_employment.update_mortgage_employment', this._onEditCoParticipant.bind(this));

      this.presenter.updateDOM();
    } else {
      // if (data.errors) this.$formCoApplicant.mogo().parseErrorObject(data.errors);
      $('#Notification').mogo().get();
    }
  };

  this._onEditCoParticipant = function (data, response) {
    if (response == 200) {
      // update model
      this.presenter.updateModel('mortgage_coparticipant_employment', data);

      // switch form states
      this.$formSteps.mogo().setStepActive(1, false);

      // analytics
      var formAnalyticsID = $('#coapplicant-form').data('analytics-id');
      this.analytics.pushEvent('form-submit', { FormID: [formAnalyticsID] });

      this.presenter.updateDOM();
    } else {
      // if (data.errors) this.$formCoApplicant.mogo().parseErrorObject(data.errors);
      $('#Notification').mogo().get();
    }
  };

  this._onDone = function () {
    this._tray().moveNext();
    var formId = this._hasCoApplicant() ? 'MogoMortgage-Form submission-Employment and CoEmployment-null-Form' : 'MogoMortgage-Form finalization-Employment-null-Form';
    this.analytics.pushEvent('form-submit', { FormID: [formId] });
  };
}